import WelcomeMessage from './WelcomeMessage/WelcomeMessage'
import SalesAgentBonusStats from './SalesAgentsBonusStats/SalesAgentsBonusStats'
import TopSalesAgents from './SalesAgentsBonusStats/TopSalesAgents'
import useHome from './useHome'
import useHomeStyles from './useHomeStyles'
import SpeedFormation from './SpeedFormation/SpeedFormation'
import { Gamification } from './Gamification'
import { Card, FlexContainer, Header1 } from '@/shared/theme/styled-components'

const Home = () => {
  const { data, isLoading, isExternal, country, type, t } = useHome()
  const { cardBonuses, child } = useHomeStyles()

  if (isLoading || !data) {
    return (
      <Card>
        <p>{t('common:fetching_data')}</p>
      </Card>
    )
  }

  return (
    <>
      <FlexContainer id='home-welcome'>
        <Card className={child}>
          <Header1>{t('home:home_welcome')}</Header1>
          <WelcomeMessage />
        </Card>
        {!isExternal && (
          <Card className={child}>
            <Header1>{t('home:speed_formation.title')}</Header1>
            <SpeedFormation />
          </Card>
        )}
      </FlexContainer>

      <Gamification />

      {!data.isAdmin && (
        <div className={cardBonuses}>
          <Header1>{t('home:bonus_summary')}</Header1>
          <SalesAgentBonusStats />
        </div>
      )}

      {type === 'energie' && country === 'fr' && (
        <Card>
          <Header1>{t('home:bonus_top_agents_primes')}</Header1>
          <TopSalesAgents />
        </Card>
      )}
    </>
  )
}

export default Home
